import React from 'react';

const StoreEmail = () => {
  const cacheKey = Object.keys(localStorage).find((key) =>
    key.endsWith('_checkUserType')
  );

  const cache = cacheKey ? JSON.parse(localStorage.getItem(cacheKey)) : null;
  const email = cache?.store_email || 'N/A';

  return (
  <div className="enh-form-group">
    <label style={{ marginLeft: '10px' }}>Email :</label>
    <span
      style={{
        padding: "12px 16px",
        borderBottom: "2px solid #e5e7eb",
        borderRadius: "8px",
        fontSize: 14,
        transition: "all 0.2s ease",
        background: "#ffffff",
        fontFamily: "inherit",
        display: "inline-block",
        minWidth: "200px"
      }}
    >
      {email}
    </span>
  </div>
);
};

export default StoreEmail;
